(function ($) {
	var
	ui = kendo.ui,
	Widget = ui.Widget;
	
	var KontoModal = Widget.extend({
		init: function (element, options) {
			var that = this;
			Widget.fn.init.call(that, element, options);
		
			/**
			 * Prilikom učitavanja sadržaja preko AJAX-a
			 * moguće je da dođe do greške na serveru.
			 */
			that._destroyDialog = false;
			that._shown = $.Deferred();
			/**
			 * Fokusirani element prije prikaza modala.
			 * Koristi se prilikom hideanja modalnog prozora da bi se fokus
			 * ponovno prenio na željeno polje.
			 */
			if (options.focusAfterClose){
				that._focusedBefore = options.focusAfterClose;	
			}else{
				that._focusedBefore = $(":focus");
			}
			
			that.element = $(element);
			that.element.addClass("modal").addClass("kontomodal");
			that.element.attr("role", "dialog");
			
			if (options.id) {
				that.element.attr("id", options.id);
			}
				
			that.isSifarnik = false;
			if (options.isSifarnik) {
				that.isSifarnik = true;
			}

			/**
			 * Razlog za tabindex:
			 * http://stackoverflow.com/questions/12630156/how-do-you-enable-the-escape-key-close-functionality-in-a-twitter-bootstrap-moda
			 */
			that.element.attr("tabindex", "-1");
			that.elementContent = that.element.children();						

			// Close event
			that.element.on("hidden.bs.modal", function () {
				//destroy zaostalih filtera i njegovog containera
				var filterMenu = $('.k-filter-menu');
				filterMenu.parent().remove();
				filterMenu.remove(); 
				
				
				/**
			     * Ako imamo više stackanih modalnih prozora, nakon ESC na jedan, više ne radi ESC na drugi.
			     * Ovo je pokušaj rješenja. Sad radi ESC, ali opet bi bilo zgodno da se fokusira element koji je bio fokusiran.
			     */
			    var modals = $(".kontomodal");
			    if (modals.length >= 2) {
			        var nextModal = modals[modals.length - 2];
			        $(nextModal).prop("tabindex", "-1");
			        $(nextModal).focus();
			    }
				
			    if (that._focusedBefore) {			    	
			        that._focusedBefore.focus();
			    }		    
				that.options.close.call(that);
				
			    if (that.options.autoDestroy)
			        that.destroy();	
			});

			that.element.on("show.bs.modal", function () {
			    that._shown.resolve(true);
			    if (that._destroyDialog)
			        that.destroy();

			    if (options.focusPrimaryButton){
			    	that.element.find(".btn-primary").focus();		
			    }
			    else if (that._focusedElement) {
			        that._focusedElement.focus();
			    }
				that.options.shown.call(that);

			});	
			
            that.element.on("shown.bs.modal", function () {
				if(that.isSifarnik)
					$(document).off('focusin.modal');

                $(function () {
                function checkPendingRequest() { 
                    if ($.active > 0) { 
                        setTimeout(checkPendingRequest, 100);
                    }else{
                        $(that.body).find('table.k-selectable').first().focus();  
                    }
                };          
                checkPendingRequest();
                });
            });
			
			//treba mu neko vrijeme da se prikaže i onda se dogodi da se unos.ready templatea izvrši prije nego se prikaže template,
			// što uzrokuje da su svi element hiden tj ne postoje na ekranu.
			if (that._isAutoOpen())
				that.show();			

			that.dialog = $("<div>");
			that.dialog.addClass("modal-dialog");
			that.dialog.addClass("modal-dialog-scrollable");
			that.dialog.attr("role", "document");

			if (typeof that.options.width !== "undefined") {
				that.dialog.css("width", that.options.width);
			}
			else if (that.options.large) {
				that.dialog.addClass("modal-lg");
			}
			that.dialog.css("max-width", that.options.maxWidth);
			
			if (that.options.modal) {
				//that.options.bs.keyboard = false;
				that.options.bs.backdrop = "static";
			}
			
			if (typeof that.options.top !== "undefined") {
				that.dialog.css("top", that.options.top);
			}			
			
			that.element.append(that.dialog);
			
			that.content = $("<div>");
			that.content.addClass("modal-content");
			if (that.options.bgColorClass) {
				that.content.addClass(that.options.bgColorClass);
			}									
			that.dialog.append(that.content);
			
			that.header = $("<div>");
			that.header.addClass("modal-header");			
			if (that.options.bgHeaderColorClass) {
				that.header.addClass(that.options.bgHeaderColorClass);
			}
			else{
				// that.header.addClass('bg-primary text-white');
			}							
			that.content.append(that.header);
			
			that.body = $("<div>");
			that.body.addClass("modal-body");
			
			that.content.append(that.body);
			
			if (that.options.buttons) {
				that.footer = $("<div>");
				that.footer.addClass("modal-footer");
				that._createButtons();
				
				if (that.options.bgFooterColorClass) {
					that.header.addClass(that.options.bgFooterColorClass);
				}					
			}
			
			that.content.append(that.footer);
			
			that._createTitle();
						
			that._createContent();
			
			that.element.modal(that.options.bs);
			
		},
		options: {
			name: "KontoModal",
			title: "",
			content: "Nema sadržaja!",
			// U slučaju da je content jQuery objekt, označava da ga treba klonirati i staviti u modal-content.
			// Koristi se kad se dialog prikazuje više puta iz istog source-a (npr. user info).
			cloneContent: false,
			isSifarnik: false,
			// Da li će se prikazati 'x' desno unutar headera.
			showClose: true,
			// Prikazuje se odmah nakon kreiranja.
			autoOpen: false,
			// Destroy odmah nakon close.
			autoDestroy: false,
			// Gumbi koji će se prikazati u footeru.
			buttons: null,
			// Koristi se modal-lg klasa.
			large: true,
			// Putanja iz koje se dohvaća sadržaj i postavlja u body.
			template: null,
			// Funkcija koja se poziva nakon što je template loadan i stavljen u body od dialoga.
			templateLoaded: function () {},
			// Širina cijelog dialoga.
			width: "70%",
			// Max-širina dialoga - bitno kod prikaza na mobilnim uređajima u slučaju da je width u pixelima
			maxWidth: "95%",
			// Defaultne postavke buttona.
			buttonDefault: {
				isPrimary: false,
				isDefault: true,
				// Klasa koja je pridjeljuje elementu buttona.
				btnClass: null,
				click: function () { this.close(); }
			},
			// Funkcija koja se zove prilikom zatvaranja
			close: function () { },
			afterClose: function () {},
			shown: function () { },
			modal: false, 
			
			pomocBtnHTML: '<button type="button" class="hide btnPomoc btn btn-light ml-auto"><i class="fas fa-question-circle"></i> Pomoć</button>',
			// Bootstrap modal opcije
			bs: {
			    keyboard: true
			}
		},
		_createTitle: function () {
			var h = $("<h4>");
			h.addClass("modal-title").append('<span class="headerTitle">'+this.options.title+'</span>');
			this.header.append(h);

			if (this.options.showClose) {
				var closeButton = $("<button>");
				closeButton
					.addClass("close")
					.attr("data-dismiss", "modal")
					.attr("type", "button")
					.attr("aria-label", "Close")
					.attr("style", "margin: 0; padding: 0;")
					;
				var s1 = $("<span>");
				s1.attr("aria-hidden", "true");
				s1.html("&times;");
				closeButton.append(s1);
								
				var s2 = $("<span>");
				s2.addClass("sr-only");
				s2.html("Zatvori");
				closeButton.append(s2);
				
				this.header.append(this.options.pomocBtnHTML);												
				this.header.append(closeButton);
			}			
		},
		_createContent: function () {
			var that = this;
			if (that.options.template) {
			    // Inicijalno postavljam title koji će se vidjeti prilikom
			    // učitavanja dialoga.
			    that.title("Molimo pričekajte");
			    that.modalContent("Učitavanje u tijeku...");
			    
				var url = that.options.template;
				var data = that.options.data;
				if (typeof data !== "object")
				    data = {};
			    data.view_as = "json";
			    // Označava modal da se mogu prilagoditi dohvaćene forme. (Npr. unos)
			    data.modal = 1;	
			    var sendType = "GET";							
				if(that.options.postParam !== undefined){
					data.postParam = that.options.postParam;
					sendType = "POST";
				}

                $.ajax({
                    url: url,
                    dataType: "json",
					type: sendType,
                    data: data,
                    success: function (data) {
                        that.title(that.options.title ? that.options.title : data.title);
	                        that._shown.done(function(){
		                        that.modalContent(data.content);
		                        /** 
		                         * Fokusirani element će se izgubiti zbog toga jer je nad dialogom postavljen tabindex=-1 (a to je zbog closeanja na ESC).
		                         */                       
		                        that._focusedElement = that.element.find(":focus");
		                        that.options.templateLoaded.call(that);
		                    });  							
                    },
                    error: function () {
                        that._destroyDialog = true;
                        that._shown.done(function(rez){
                        	if (rez)
                            	that.close();	
                        });
                    }
                });
			}
			else {
				var content = that.elementContent;
				if (content.length > 0) {
					this.body.append(content);
				}
				else {
					content = that.options.content;
					if (!content)
						content = "";
					if (content instanceof jQuery) {
						var newElement = that.options.cloneContent ? content.clone() : content;

						this.body.append(newElement);
						
						that.element.on("show.bs.modal", function () {
							var scripts = newElement.find("script");
							scripts.each(function (index, element) {
								eval($(this).html());
							});
						});
					}
					else {
						this.body.html(content);
					}
				}
					
			}
			
		},
		_createButtons: function () {
			var that = this;
			$.each(that.options.buttons, function (name, value) {
				var opts = {};
				if (typeof value === "function")
					opts.click = value;
				else
					opts = value;
				var opts = $.extend({}, that.options.buttonDefault, opts);
				
				var btn = $("<button>");
				btn.html(name);
				btn.attr("type", "button");
				btn.addClass("btn");
				if (opts.id) {
					btn.attr("id", opts.id);
				}						
				if (opts.isPrimary)
					btn.addClass("btn-primary");
				else if (opts.isDefault)
					btn.addClass("btn-light");
				if (opts.btnClass)
					btn.addClass(opts.btnClass);
				if (opts.isDisabled)
					btn.prop('disabled', true);	
				if (opts.ikona){
					var oldHtml = btn.html();
					btn.html("<i class='" + opts.ikona + "'></i> " + oldHtml);
				}					
				if (opts.isOdustani)
					btn.addClass("btn-odustani-modal");
									
				btn.click(opts.click.bind(that));
				
				that.footer.append(btn);				
			});
			
			if (that.options.pullButtonsLeft){
				that.footer.append('<span class="mr-auto"></span>');	
			}
		},
		/**
		 * Funkcija bitna za template koji se učitava preko AJAX-a.
		 * Ako se dialog odmah otvori, onda stoji prazan, što i nema nekog smisla.
		 * Eventualno bi se moglo postaviti učitavanje?
		 */
		_isAutoOpen: function () {
	       return this.options.autoOpen === true;
		},
		show: function () {
			this.element.modal("show");
		},
		open: function () {
			this.show();
		},
		close: function () {
			this.element.modal("hide");
		},
		title: function () {
            if (!arguments.length) {
                //return this.header.find(".modal-title").html();
                return this.header.find(".modal-title .headerTitle").html(title);
            }
            else {
                var title = arguments[0];
                //this.header.find(".modal-title").html(title);   
    			this.header.find(".modal-title .headerTitle").html(title);
            }
		},
		modalContent: function () {
		    if (!arguments.length) {
		        return this.body.html();
		    }
		    else {
		        var content = arguments[0];
		        this.body.html(content);
		    }
		},
		destroy: function () {
			var that = this; 
			$(function () {
		        function checkPendingRequest() { 
		            if ($.active > 0) { 
		                setTimeout(checkPendingRequest, 100);
		            }else{
					    that.element.data("bs.modal", null);
			            that.element.remove();
		            	var brModala = $(".kontomodal").length;
		            	if (brModala > 0){
		            	    var kontoM = $(".kontomodal").data("bs.modal");
		            		if (kontoM && kontoM.isShown){
		            			$("body").addClass("modal-open");
		            		}
		            	}
		            }
		        };			
	        	checkPendingRequest();
			});
		}
	});
	
	ui.plugin(KontoModal);
}) (jQuery);